import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from '@meplis/components';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalOptions } from '@meplis/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  Form,
  FormBuilder,
  FormGroup,
  FormsModule,
  NgForm,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  ApiFollowService,
  ProgramService,
  ToastService,
} from '@meplis/services';

@Component({
  selector: 'app-invite-code-modal',
  imports: [
    CommonModule,
    ModalComponent,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './invite-code-modal.component.html',
  styleUrl: './invite-code-modal.component.scss',
})
export class InviteCodeModalComponent {
  public modalOptions: ModalOptions;

  public formGroup: FormGroup;
  public isSaving: boolean = false;

  constructor(
    private _dialogRef: MatDialogRef<InviteCodeModalComponent>,
    private _translateService: TranslateService,
    private _formBuilder: FormBuilder,
    private _apiFollowService: ApiFollowService,
    private _toastService: ToastService,
    private _programService: ProgramService
  ) {
    this.modalOptions = {
      title: this._translateService.instant('INVITE_CODE.INVITE_CODE_TITLE'),
      subTitle: this._translateService.instant('INVITE_CODE.DESCRIPTION'),
      positiveButtonLabel: this._translateService.instant('INVITE_CODE.SUBMIT'),
      negativeButtonLabel: this._translateService.instant('INVITE_CODE.CANCEL'),
      showNegativeButton: true,
      showPositiveButton: true,
      closeable: true,
    };

    this.formGroup = this._formBuilder.group({
      inviteCode: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^(?=(?:.*[0-9]){3})(?=(?:.*[A-Z]){4})[A-Z0-9]{7}$/
          ),
        ],
      ],
    });
  }

  public async submitInviteCode(): Promise<void> {
    if (!this.formGroup.valid) {
      return;
    }

    this.isSaving = true;

    try {
      await this._apiFollowService.sendInviteCode(
        this.formGroup.value.inviteCode
      );

      this._programService.setProgramListReload();

      this._toastService.showSuccess('INVITE_CODE.SUCESS');
      this._dialogRef.close(this.formGroup.value.inviteCode);
    } catch (error) {
      this._toastService.showError(error);
    }

    this.isSaving = false;
  }

  public closeModal(): void {
    this._dialogRef.close();
  }
}
